export default __webpack_public_path__ + "static/media/lemlist-campaign.d9ecd674.svg";